import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import api from '../api';
import {
  FETCH_PROFIL,
  ON_UPDATE_PROFILE,
  ON_CHANGE_PASSWORD_PROFILE
} from 'constants/ActionTypes';
import { userSignOut, updateProfileAuthUser } from 'actions/Auth';
import { fetchProfileSuccess, updateProfileSuccess, showProfileMessage, showProfileButtonLoader, showProfilePasswordButtonLoader, updateProfilePasswordSuccess } from 'actions/Profile';


function* getProfile () {
  try {
    const token = localStorage.getItem('token');
    const user = yield call(api.authApi.getProfile, token);

    if (user.errorMessage) {
      yield put(showProfileMessage(user.errorMessage, true));
    } else {
      yield put(fetchProfileSuccess(user));
    }
  } catch (error) {
    yield put(showProfileMessage(error.errorMessage, true));
    yield put(userSignOut());
  }
}

function* updateProfile({ payload }) {
  try {
    yield put(showProfileButtonLoader());
    const authToken = localStorage.getItem('token');
    const user = yield call(api.profileApi.updateProfile, { payload, authToken });

    if (user.errorMessage) {
      yield put(showProfileMessage(user.errorMessage, true));
    } else {
      yield put(updateProfileSuccess({ message: 'user.updateProfileSuccess'}));
      yield put(updateProfileAuthUser(user));
    }
  } catch (error) {
    yield put(showProfileMessage(error.errorMessage, true));
    yield put(userSignOut());
  }
}

function* changePassword({ payload }) {
  try {
    yield put(showProfilePasswordButtonLoader());
    const authToken = localStorage.getItem('token');
    const user = yield call(api.profileApi.changePassword, { payload, authToken });

    if (user.errorMessage) {
      yield put(showProfileMessage(user.errorMessage, true));
    } else {
      yield put(updateProfilePasswordSuccess(user));
    }
  } catch (error) {
    yield put(showProfileMessage(error.errorMessage, true));
    yield put(userSignOut());
  }
}

export function* fetchProfile () {
  yield takeEvery(FETCH_PROFIL, getProfile);
}

export function* onUpdateProfile () {
  yield takeEvery(ON_UPDATE_PROFILE, updateProfile);
}

export function* onChangePasswordProfile () {
  yield takeEvery(ON_CHANGE_PASSWORD_PROFILE, changePassword);
}

export default function* rootSaga () {
  yield all ([
    fork(fetchProfile),
    fork(onUpdateProfile),
    fork(onChangePasswordProfile)
  ]);
}


// WEBPACK FOOTER //
// ./sagas/Profile.js